import { z } from "zod";
export const AsyncLinkDataSchema = z.object({
    self: z.string().optional(),
    first: z.string().optional(),
    last: z.string().optional(),
    prev: z.string().optional(),
    next: z.string().optional(),
    search: z.string().optional(),
});
export const AsyncMetadataSchema = z.object({
    from: z.number(),
    limit: z.number(),
    totalItems: z.number(),
    totalPages: z.number(),
    locale: z.string(),
    ssr: z.boolean().optional(),
    prefetchAll: z.boolean().optional(),
});
export const AsyncConfigSchema = z.object({
    linkdata: AsyncLinkDataSchema,
    metadata: AsyncMetadataSchema.optional(),
    errorTitle: z.string().optional(),
    errorText: z.string().optional(),
    retryText: z.string().optional(),
});
//# sourceMappingURL=index.js.map